export const name = 'ofrs-web';
export const version = '';
export const buildDate = '2026-09-15 22:01:05';
